import React from 'react';
import { Modal as AntModal } from 'antd';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { AmountWrapper } from '../CongratsModal/CongratsModal.style';
import { SpinNoticeFilled } from '@assets';

const Modal = styled(AntModal)`

.ant-modal-title {
    text-align: center;
    color: ${props => props.theme.primaryColor};
}

.ant-modal-content {
    padding-top: 100px !important;
    text-align: center;
    position: relative;
}

.ant-modal-footer {
    text-align: center;

    .ant-btn-default {
        display: none !important;
    }
}

#modal-icon {
    position: absolute;
    top: 10px;
    left: 50%;
    transform: translate(-50%, 0);
}
`;

const SpinAlert = ({
    open,
    title,
    description,
    isError,
    onOk,
}) => {
    const { t } = useTranslation();

    return (
        <Modal
            centered
            destroyOnClose
            closable={false}
            width={320}
            title={title}
            open={open}
            onOk={onOk}
            okText={t('common.ok')}
        >
            <SpinNoticeFilled id='modal-icon' />
            {isError
                ? description
                : <AmountWrapper style={{ marginTop: 0, textTransform: 'uppercase' }}>
                    {description}
                </AmountWrapper>
            }
        </Modal>
    );
}

export default SpinAlert;